import React from 'react';
import classNames from 'classnames';

import { ProductFormProvider } from '../../../context/product-form-context';

import Gallery from '../Gallery';
import Info from '../Info';

const ns = `product-main`;

const Main = ({
	location,
	product,
	globalSettings,
	reviewsData,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	const preselectedVariant = product.variants.find(_variant => {
		return _variant.sku === product.productDetails?.defaultVariantSku;
	});

	return (
		<ProductFormProvider
			product={product}
			useUrlParameter
			usePrettyUrlParameters
			preselectedVariant={preselectedVariant}
			preselect1stAvailableVariant
			useReplaceState
			renderingScheme={{
				colour: 'swatch',
				color: 'swatch',
				size: 'button',
				0: 'button',
				1: 'swatch',
				2: 'default',
			}}
			sortOrder={[
				'size',
				'colour',
				'color',
			]}
		>
			<div className={rootClassnames}>
				<div className={`${ ns }__cols container`}>
					<div className={`${ ns }__col`}>
						<Gallery
							product={product}
						/>
					</div>
					<div className={`${ ns }__col`}>
						<Info
							location={location}
							product={product}
							globalSettings={globalSettings}
							reviewsData={reviewsData}
						/>
					</div>
				</div>
			</div>
		</ProductFormProvider>
	);
};

export default Main;
